import { Component, OnInit } from '@angular/core';
import { DatabusService } from '../../shared/services/databus.service';
import { ValidationService } from '../../shared/services/validation.service';
import { AddProfile } from './addprofile';
import { KeyboardServiceService } from '../../shared/keyboard-service/keyboard-service.service';
import { Idle } from '@ng-idle/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-addprofile',
  templateUrl: './addprofile.component.html',
  styleUrls: ['./addprofile.component.scss']
})

export class AddprofileComponent implements OnInit {
  showSpinner: Boolean = false;
  showError: Boolean = false;
  showEmail: Boolean = false;
  showServerError: Boolean = false;
  showAccountChallenge: Boolean = true;
  showLoginChallenge: Boolean = false;
  errorText: String = '';
  formValidate: any = {};

  signUpArray = ['firstName', 'lastName', 'email', 'password', 'password2']; // need to set next and prev fields
  signup = new AddProfile('', '', '', '', '');

  error = {};

  constructor (
    private keyboardSvc: KeyboardServiceService,
    private dataSvc: DatabusService,
    private validate: ValidationService,
    private idle: Idle,
    private router: Router
  ) {
    this.keyboardSvc.currentModel = this.signUpArray[0];
    if (this.dataSvc.forceRegistration) {
      this.showAccountChallenge = false;
    }
    if (this.dataSvc.currentEmail) {
      this.signup.email = this.dataSvc.currentEmail;
    }
  }

  DoRegister () {
    this.showAccountChallenge = false;
  }

  GoLogin () {
    this.router.navigate(['/login']);
  }

  TabToNextField (val) {
    let currentIdx = this.signUpArray.indexOf(this.keyboardSvc.currentModel);
    if (val === 'NEXT' && currentIdx !== this.signUpArray.length - 1) {
      this.keyboardSvc.currentModel = this.signUpArray[currentIdx + 1];
    } else if (currentIdx !== 0) {
      this.keyboardSvc.currentModel = this.signUpArray[currentIdx - 1];
    }
  }

  SetModelFromKeyboard (val) {
    let currentModel = this.keyboardSvc.getCurrentModel();

    if (val === 'DELETE') {
      this.signup[currentModel] = this.keyboardSvc.deleteValue(this.signup[currentModel]);
    } else if (val === 'NEXT' || val === 'PREV') {
      this.TabToNextField(val);
    } else {
      this.signup[currentModel] = this.signup[currentModel] + val;
    }
  }

  SaveProfile () {
    this.showSpinner = true;
    this.dataSvc.setInitProfile(this.signup);
    let validForm = this.ValidateForm();
    if (validForm) {
      this.showError = false;
      this.SaveAccount();
    } else {
      this.showSpinner = false;
      this.error = {
        firstname: this.signup.firstName === '' ? true : false,
        lastname: this.signup.lastName === '' ? true : false,
        email: this.signup.email === '' ? true : false,
        password: this.signup.password === '' ? true : false,
        passwordMatch: this.signup.password === this.signup.password2 ? false : true
      }
      this.showError = true;
    }
  }

  SaveAccount () {
    this.validate.addAccount(this.signup)
    .then((results) => {
      var status = parseInt(results.status);
      if (status === 200) {
        this.dataSvc.setInitProfile(this.signup);
        if (this.dataSvc.currentTicket){
          this.AssignTicket();
        } else {
          this.AssignClubCard();
        }
      }

      if (status === 409) {
        this.showLoginChallenge = true;
      }

      if (status >= 400 && status !== 409) {
        this.showSpinner = false;
        this.showServerError = true;
        this.errorText = results.message;
      }
    });
  }

  AssignClubCard () {
    let assign = {
      email: this.signup.email,
      cardCode: this.dataSvc.currentClubCard
    };
    this.validate.assignCardCode(assign)
    .then((results) => {
      if (results.status === '201') {
        if (this.dataSvc.currentTicket) {
          this.AssignTicket();
        } else {
          this.router.navigate(['/scananother']);
        }
      }
    });
  }

  AssignTicket() {
    let ticket = {
      email: this.dataSvc.currentEmail,
      code: this.dataSvc.currentTicket.code
    };
    this.validate.assignTicketAccount(ticket)
    .then((results) => {
      if (results.status === '204') {
        this.dataSvc.redeemValue = results.value;
        this.router.navigate(['/success']);
      }
      if (results.status === '409') {
        this.dataSvc.errorMessage = results.message;
        this.router.navigate(['/invalid']);
      }
    });
  }

  Cancel () {
    this.router.navigate(['/scanticket']);
  }

  isCurrent (name) {
    return this.keyboardSvc.currentModel === name;
  }

  ValidateForm (): boolean {
    return this.dataSvc.initProfileValid();
  }

  CloseError () {
    this.showError = false;
  }

  ngOnInit() {
    if (!this.dataSvc.currentTicket) {
      this.Cancel();
    }
    if (!this.idle.isRunning()) {
      this.idle.watch();
    };
  }

}



// WEBPACK FOOTER //
// C:/Magento2/gs-kiosk/src/app/routes/addprofile/addprofile.component.ts